import { createSlice } from "@reduxjs/toolkit";

const initialProductState = {
  products: {
    items: [],
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
  },
  selectedProductId: "",
};

const productSlice = createSlice({
  name: "product",
  initialState: initialProductState,
  reducers: {
    setProductList: function (state, actions) {},
    setProductDetails: function (state, actions) {},
    setSelectedProductId: function (state, actions) {
      state.selectedProductId = actions.payload;
    },
  },
});

export const { setProductDetails, setProductList, setSelectedProductId } = productSlice.actions;
export default productSlice.reducer;
